import { faFilter } from '@fortawesome/pro-regular-svg-icons';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { clsx } from 'clsx';

import { PlatformApp } from '@typings';
import { platformAppsTemplatesTagsSelector } from '@selectors';
import { useSelector } from '@hooks';
import { useTagsSearchParam } from '@hooks/platformApps';

import { Badge, Button, Icon, Popover } from '@components/Shared';

type Tag = PlatformApp.Template['tags'][number];

export const PlatformAppsTemplatesFilters: React.FC = () => {
  const templatesTags = useSelector(platformAppsTemplatesTagsSelector);

  const { tags, toggleTag } = useTagsSearchParam();

  const isFilteredByTags = tags.length > 0;

  const filterText = isFilteredByTags ? 'Tags' : 'All';

  const makeTag = (tag: Tag) => {
    const isActive = tags.includes(tag);
    const variant = isActive ? 'primary' : 'grey';

    return (
      <Button theme key={tag} onClick={() => toggleTag(tag)}>
        <Badge variant={variant} className="text-body-small">
          {tag}
        </Badge>
      </Button>
    );
  };

  return (
    <Popover showArrow={false} side="bottom" align="end">
      <div
        slot="trigger"
        className="group flex h-12 w-64 items-center gap-2.5 rounded-lg bg-white px-4 py-2"
      >
        <Icon
          icon={faFilter}
          className={clsx('text-[20px] text-neural-04 transition-colors', {
            'text-primary': isFilteredByTags,
          })}
        />
        <p className="flex-1 text-left">{filterText}</p>
        <Icon
          icon={faCaretDown}
          className="text-[20px] text-neural-04 transition-colors group-hover:text-rebecca"
        />
      </div>
      <div className="flex w-96 flex-col gap-4">
        <div>
          <p>Tags</p>
          <div className="mb-4 mt-2 h-px bg-neural-02" />
          <div className="flex flex-wrap gap-2">
            {templatesTags.map(makeTag)}
          </div>
        </div>
      </div>
    </Popover>
  );
};
